const countEnum = [
  { label: '1 Person', value: 1 },
  { label: '2 Personen', value: 2 }
]

export default countEnum
